import { BRAND_PRIMARY, BRAND_SECONDARY } from '../branding/config';

export function applyBranding(): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', BRAND_PRIMARY);
  root.style.setProperty('--brand-secondary', BRAND_SECONDARY);
}
